// extracted by mini-css-extract-plugin
export var bubble = "_26-0";
export var container = "_26-f";
export var contrastBorder = "_26-g";
export var greyOut = "_26-2";
export var initialsColor0 = "_26-3";
export var initialsColor1 = "_26-4";
export var initialsColor10 = "_26-d";
export var initialsColor11 = "_26-e";
export var initialsColor2 = "_26-5";
export var initialsColor3 = "_26-6";
export var initialsColor4 = "_26-7";
export var initialsColor5 = "_26-8";
export var initialsColor6 = "_26-9";
export var initialsColor7 = "_26-a";
export var initialsColor8 = "_26-b";
export var initialsColor9 = "_26-c";
export var initialsWrapper = "_26-1";
export var large = "_26-l";
export var medium = "_26-k";
export var mediumSmall = "_26-j";
export var mediumSmallMedium = "_26-o";
export var micro = "_26-h";
export var small = "_26-i";
export var tiny = "_26-n";
export var xTiny = "_26-m";